import React from 'react';
import { Typography } from '@mui/material';

// Keep requirements available without hover, long press, or an icon-only control.
export default function PasswordRequirements({ id }) {
    return (
        <Typography id={id} variant="body2" sx={{ mt: 1, textAlign: 'left' }}>
            Use 8–30 characters, including an uppercase letter, a lowercase letter,
            a number, and a special character: {'!@#$%^&*(),.?":{}|<>'}.
        </Typography>
    );
}
